import * as LogisticModelsActions from './logisticModels';

const Actions = {
  ...LogisticModelsActions,
};

export default Actions;
